import { createApiCall } from 'lib/base';
import { generateEndpoint } from 'utils/urlHelpers';

const makeListCall = (key: string, path: string) =>
  createApiCall(key, (params?: Record<string, any>) => ({
    endpoint: generateEndpoint({
      host: `api/admin/${path}`,
      params: params || {},
    }),
    method: 'GET',
  }));

export const listIndustries = makeListCall(
  'FETCH_ICB_INDUSTRIES',
  'stock-icb/industries'
);
export const listSuperSectors = makeListCall(
  'FETCH_ICB_SUPERSECTORS',
  'stock-icb/supersectors'
);
export const listSectors = makeListCall(
  'FETCH_ICB_SECTORS',
  'stock-icb/sectors'
);
export const listSubSectors = makeListCall(
  'FETCH_ICB_SUBSECTORS',
  'stock-icb/subsectors'
);
